import { useTranslation } from 'react-i18next';
import { getProjectTypeLabel } from '../types';
import type { ProjectType } from '../types';

const typeStyles: Record<ProjectType, string> = {
  service: 'bg-info-100 text-info-700 border-info-200',
  hour_bank: 'bg-warning-100 text-warning-700 border-warning-200',
  development: 'bg-violet-100 text-violet-700 border-violet-200',
};

interface ProjectTypeBadgeProps {
  type: ProjectType;
  size?: 'sm' | 'md';
}

export default function ProjectTypeBadge({ type, size = 'sm' }: ProjectTypeBadgeProps) {
  const { t } = useTranslation();
  const sizeClass = size === 'md' ? 'text-sm px-3 py-1' : 'text-xs px-2 py-0.5';
  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${typeStyles[type]} ${sizeClass}`}>
      {getProjectTypeLabel(type, t)}
    </span>
  );
}
